var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')

var Globals = require('./Globals');

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKButton,
} = MK;

import Icon from './wrappers/ReUpIcon';

var {
  AppRegistry,
  Text,
  View,

  StyleSheet,
} = ReactNative;

var ReUpText = require('./ReUpText');

var ReUpTabBar = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager: {},
      text: "",
      isSecondary: false,
      useShadow: true,
      buttonFeatures: [],
      showFeature: function(feature, index, extras){},
      hideFeature: function(){},
      initialTabSelected: -1,
      inactiveBackgroundColor: 'transparent',
      activeBackgroundColor: 'red',
      textColor:'blue',
      iconColor:'red',
      rippleColor:'rgba(255,0,0,.3)',
      addedTextStyle:{},
      barColor:'transparent',
      layout:{width:0,height:0},
      canDismiss:true,
      showX:false,
    }
  },

  getInitialState : function()
  {
    var barWidth = 0;
    if( this.props.buttonFeatures.length > 0 )
    {
      barWidth = this.props.layout.width / this.props.buttonFeatures.length;
    }

    return {
      tabIndexSelected: -1,
      visible: true,
      opacity: new Animated.Value(1),
      barLeft: new Animated.Value(0),
      barWidth: barWidth,
    }
  },

  componentDidMount : function()
  {
    this.setTabSelected(this.props.initialTabSelected);
  },

  componentWillReceiveProps : function(newProps)
  {
    if( typeof newProps.buttonFeatures !== 'undefined' )
    {
      var barWidth = 0;
      if( newProps.buttonFeatures.length > 0 )
      {
        barWidth = this.props.layout.width / newProps.buttonFeatures.length;
        if( barWidth != this.state.barWidth ) this.setState({barWidth})
      }
    }
  },

  setTabSelected : function(index, showFeatureAsWell)
  {
    if( typeof showFeatureAsWell === 'undefined' ) showFeatureAsWell = true;

    if( index != this.state.tabIndexSelected )
    {
      var newLeft = index*this.state.barWidth;
      if( this.state.tabIndexSelected < 0 )
      {
        if( showFeatureAsWell ) this.props.showFeature(JSON.parse(JSON.stringify(this.props.buttonFeatures[index])), index, {shouldHideActionBar:true});
        this.setState({tabIndexSelected:index, barLeft:new Animated.Value(newLeft)});
      }
      else if( index >= 0 )
      {
        if( showFeatureAsWell ) this.props.showFeature(JSON.parse(JSON.stringify(this.props.buttonFeatures[index])), index, {shouldHideActionBar:true});
        Animated.spring(
          this.state.barLeft,
          {
            toValue: newLeft,
            tension: 10,
            friction: 5,
          },
        ).start();
      }
      this.setState({tabIndexSelected:index});
    }
  },

  setVisible : function(visible, animated)
  {
    if( typeof animated === 'undefined' ) animated = true;
    if( visible == this.state.visible ) return;

    var thisThing = this;
    if( visible )
    {
      thisThing.setState({visible:visible});
      Animated.timing(
       thisThing.state.opacity,
       {toValue: 1,
       duration:300},
      ).start(function()
      {
      });
    }
    else
    {
      Animated.timing(
       thisThing.state.opacity,
       {toValue: 0,
       duration:300},
      ).start(function()
      {
        thisThing.setState({visible:visible});
      });
    }
  },

  render: function()
  {
    var thisThing = this;
    var tabIndexSelected = this.state.tabIndexSelected;

    var inactiveBackgroundColor = this.props.inactiveBackgroundColor;
    var rippleColor = this.props.rippleColor;
    var activeBackgroundColor = this.props.activeBackgroundColor;
    var textColor = this.props.textColor;
    var iconColor = this.props.iconColor;
    var visible = this.state.visible;
    var showFeature = this.props.showFeature;
    var hideFeature = this.props.hideFeature;
    var addedTextStyle = this.props.addedTextStyle;

    if( !visible ) return null;

    return (
      <Animated.View style={[this.props.style,{flexDirection:'row',  height:50, opacity: this.state.opacity, alignItems:'stretch'}, this.props.canDismiss ? Globals.TAB_STYLE_ADJUSTMENT : {}]}
        onLayout={(evt)=>
        {
          var barWidth = evt.nativeEvent.layout.width / thisThing.props.buttonFeatures.length;
          if( barWidth != thisThing.state.barWidth ) thisThing.setState({barWidth});
        }}>
        {
          !visible ? null :
          this.props.buttonFeatures.map(function(feature, index)
          {
            if( typeof feature === 'undefined' ) return null;
            var icon = null;
            var buttonTitle = typeof feature.data.shortTitle === 'undefined' ? feature.data.title : feature.data.shortTitle;
            if( iconColor != 'transparent' ) icon = feature.data.icon.replace("fa-", "");

            return (
              <View style={{flex:1, alignSelf:'stretch'}}>
                <MKButton
                  backgroundColor={inactiveBackgroundColor}
                  shadowRadius={0}
                  shadowOffset={{width:0, height:0}}
                  shadowOpacity={0}
                  shadowColor={'transparent'}
                  style={{flex:1, alignSelf:'center'}}
                  rippleColor={rippleColor}
                  maskBorderRadius={0}
                  enabled={visible}
                  style={{pointerEvents:visible ? 'auto' : 'none', flex:1, alignSelf:'stretch', display:'flex'}}
                  onPress={function()
                    {
                      if( index == tabIndexSelected )
                      {
                        if( thisThing.props.canDismiss )
                        {
                          thisThing.setTabSelected(-1);
                          hideFeature();
                        }
                      }
                      else
                      {
                        thisThing.setTabSelected(index);
                      }
                    }}>
                 <View style={{flexDirection:'row', alignItems:'center', justifyContent:'center', alignSelf:'center', flex:1}}>
                    <View style={{flexDirection:'row', alignItems:'center', flexGrow:1, flexShrink:1, flexBasis:'auto'}}>
                      <View style={{alignSelf:'center', marginLeft:2}}>{ icon != null ? <Icon name={icon} size={20} color={iconColor}/> : null }</View>
                      { icon != null ? <View style={{width:4}}/> : null }
                      <View style={{flexDirection:'row', flex:1, alignSelf:'flex-start'}}>
                        <ReUpText pointerEvents="none"
                            style={[{paddingLeft:4,
                                    paddingRight:4,
                                    wordWrap:'break-word',
                                    fontSize:14,
                                    textAlign:'center',
                                    color: textColor,
                                    backgroundColor:'transparent',
                                    fontWeight: tabIndexSelected == index ? 'bold' : 'normal'}, addedTextStyle]}>
                          {buttonTitle}
                        </ReUpText>
                      </View>
                    </View>
                  </View>
                </MKButton>

                {
                  thisThing.props.showX && (tabIndexSelected == index) ?
                    <View style={{position:'absolute', top:4, left:4, width:20, height:20, opacity:.4}}>
                      <Icon name={'times'} size={12} color={textColor}/>
                    </View>
                  : null
                }
              </View>
            );
          })
        }
        <Animated.View pointerEvents="none" style={{position:'absolute', bottom:0, opacity:tabIndexSelected >= 0 ? 1 : 0, left:this.state.barLeft, height:6, width:this.state.barWidth, backgroundColor:this.props.barColor}} />
      </Animated.View>
    )
  }
});

module.exports = ReUpTabBar;



// WEBPACK FOOTER //
// ./src/ReUpTabBar.js